import { Col, Collapse, Flex, Row, Steps } from 'antd';
import { Subtitle, Text } from 'components/mvp-typography';
import { halfCol } from 'lib/utils/antd';

export function UserKnowledgePanelContent() {
  return (
    <Flex vertical gap={16}>
      <Text>
        This page is for managing ConcussionRx assessments for a specific
        test-taker. You can see whether the assessment is pending, activated, or
        expired. You can generate a new link at any time. Only one active link
        can exist at any time.
      </Text>
      <Row>
        <Col {...halfCol}>
          <Flex vertical gap={'small'}>
            <Text style={{ fontWeight: 'bold' }}>
              What steps do I need to take?
            </Text>
            <Steps
              size="small"
              current={-1}
              direction="vertical"
              style={{ padding: 8 }}
              progressDot
              items={[
                {
                  title: 'Generate a link',
                  description:
                    'Click the "Create assessment" button in the panel below.'
                },
                {
                  title: 'Send the link',
                  description:
                    'Copy the URL that appears, and send it to the test-taker using your regular contact methods.'
                },
                {
                  title: 'Analyze the results',
                  description:
                    'Available after the test-taker completes their assessment.'
                }
              ]}
            />
          </Flex>
        </Col>
        <Col {...halfCol}>
          <Flex vertical gap={'small'}>
            <Text style={{ fontWeight: 'bold' }}>
              What steps does my test-taker need to take?
            </Text>
            <Steps
              size="small"
              current={-1}
              style={{ padding: 8 }}
              direction="vertical"
              progressDot
              items={[
                {
                  title: 'Open the link',
                  description:
                    'The test-taker will be prompted to setup their account, or automatically signed in if they have completed this step before.'
                },
                {
                  title: 'Complete the assessment',
                  description: 'The assessment expires after 72 hours.'
                },
                {
                  title: 'Assessment completed',
                  description:
                    'Once completed, the link will expire. A new link is required for future assessments.'
                }
              ]}
            />
          </Flex>
        </Col>
      </Row>
    </Flex>
  );
}

export function UserKnowledgePanel() {
  return (
    <Collapse style={{ width: '100%' }}>
      <Collapse.Panel
      className='plausible-event-name=assessmentManager:moreInfo:dropdown'
        header={<Subtitle>What is this page?</Subtitle>}
        key="page-info"
      >
        <UserKnowledgePanelContent />
      </Collapse.Panel>
    </Collapse>
  );
}
